/* =========================

  Recommend02

============================ */
import React from 'react';
import styled from "styled-components";
import { useSelector } from "react-redux";
import sanitize from "sanitize-html";

import {break_point_sp} from "../../../Styled/mixin";
import Image from "../../../Components/Part/Image";

import Btn from "../part/Btn";

/* -------------------------

  component

---------------------------- */
function Recommend02( props ) {
  const state = useSelector((state)=>state.datasRecommend);
  //const recommend = state[props.flagment];

  let recommend02 = [];
  props.products.map((p,i)=>(
    state.map((r,j)=>(
      (p === r.flagName)?recommend02.push(r):""
    ))
  ))

  let noteCount = 1;
  for(let i = 0 ; i < recommend02.length ; i++ ){

    // ボディキャッチの注記番号を挿入
    let bodyCopyArr = recommend02[i].bodyCopy.re02.split("<sup></sup>");
    recommend02[i].bodyCopy.re02 = "";
    for(let k = 0 ; k < bodyCopyArr.length ; k++){
      if((k + 1) < bodyCopyArr.length){
        recommend02[i].bodyCopy.re02 += `${bodyCopyArr[k]}<sup>※${noteCount + k}</sup>`;
      }else{
        recommend02[i].bodyCopy.re02 += `${bodyCopyArr[k]}`;
      }
    }

    // 注記の注記番号つきのオブジェクトを追加作成
    recommend02[i].noteWithNum = [];
    for(let j = 0 ; j < recommend02[i].note.length ; j++){
      recommend02[i].noteWithNum.push(`※${noteCount}：${recommend02[i].note[j]}`);
      noteCount++;
    }
  }

  return (
    <Styled className="p-result__section_recommend02 p-sec">
      <div className="p-result__section__inner l-inner--1100 l-inner--92">

        <div className="p-result__section__heading">
          <div className="p-result__section__heading__inner">
            <h2 className="c-font_f--km">その他の<br className="sp_only" /><span>おすすめ商品</span>はこちらです！</h2>
          </div>
        </div>

        <div className="p-result__block_recommend02 p-result__block">
          <div className="p-result__block__inner">

            <div className="p-result__box_recommend02 p-result__cta">
              <div className="p-result__box__inner">
                {recommend02.map((re02,i)=>(
                  <React.Fragment key={i}>

                    <div className={`p-result__cta__heading p-result__cta__heading__${i} c-result__ballow`}>
                      <div className="c-result__ballow__inner">
                        <h4 className="c-font_f--km" dangerouslySetInnerHTML={{__html:sanitize(re02.catchCopy.main)}}></h4>
                        {(re02.catchCopy.main_note !== "")?<p className="note">{re02.catchCopy.main_note}</p>:""}
                      </div>
                    </div>

                    <div className={`p-result__cta__contents p-result__cta__contents__${i} l-box`}>
                      <div className="p-result__cta__contents__inner">

                        {/* <p className="p-result__cta__txt_catch l-box__txt c-font_f--km">にんにく健康食品<br /><span>19年連続売上No.1！</span><sup>※1</sup></p> */}

                        <p className="p-result__cta__txt_catch c-font_f--km" dangerouslySetInnerHTML={{__html:sanitize(re02.bodyCopy.re02)}}></p>

                        <div className="p-result__cta__img">
                          <div className={`p-result__cta__rank`}>
                            <p className="img">
                              <Image
                                src={`/assets/img/result/icn_rank_0${2+i}.png`}
                                alt={""}
                              ></Image>
                            </p>
                          </div>
                          <p className="img_01">
                            <Image
                              src={`/assets/img/result/products/${re02.flagName}.png`}
                              alt={re02.productName}
                            ></Image>
                          </p>
                        </div>
                        <p className="p-result__cta__txt_product_name">
                          {re02.productName}
                          <span>{re02.productSize}</span>
                        </p>
                        <p className="p-result__cta__txt_price">{re02.productPrice}<span>円（税込）</span></p>

                        <div className="p-result__cta__part">
                        <Btn href={re02.linkAbout}>詳しく見てみる</Btn>
                        </div>

                      </div>
                    </div>

                    <div className={`p-result__cta__footing p-result__cta__footing__${i}`}>
                      <div className="p-result__cta__footing__inner">
                        {re02.noteWithNum.map((n,j)=>(
                          <p className="txt_note" key={`note_${j}`}>
                            {n}
                          </p>
                        ))}
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Styled>
  );
}

export default Recommend02;

/* -------------------------

  styled

---------------------------- */

/*
ALL
---------------------------- */
const Styled = styled.section`
  margin: 60px 0;

  .p-result__section__heading{
    margin-bottom: 45px;
    .p-result__section__heading__inner{
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }
    h2{
      display: inline-block;
      font-size: 40px;
      position: relative;
      padding: 0 120px;
      color: #451700;
      span{
        color: #345d27;
      }
      &::before{
        content: " ";
        display: block;
        width: 100px;
        height: 51px;
        background: url(${process.env.PUBLIC_URL}/assets/img/result/recommend02/icn_leaf_left.png) no-repeat;
        background-size: 100%;
        position: absolute;
        transform: translateY(50%);
        bottom: 50%;
        left: 0;
      }
      &::after{
        content: " ";
        display: block;
        width: 100px;
        height: 51px;
        background: url(${process.env.PUBLIC_URL}/assets/img/result/recommend02/icn_leaf_right.png) no-repeat;
        background-size: 100%;
        position: absolute;
        transform: translateY(50%);
        bottom: 50%;
        right: 0;
      }
    }
  }

  .p-result__block_recommend02{
    .p-result__box_recommend02{
    .p-result__box__inner{
      display: grid;
      gap: 0 60px;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 0.1fr 0.1fr 0.1fr;
      width: 100%;
    }
    .p-result__cta__heading__0{
      grid-column: 1;
      grid-row: 2;
    }
    .p-result__cta__heading__1{
      grid-column: 2;
      grid-row: 2;
    }
    .p-result__cta__contents__0{
      grid-column: 1;
      grid-row: 3;
    }
    .p-result__cta__contents__1{
      grid-column: 2;
      grid-row: 3;
    }
    .p-result__cta__footing__0{
      grid-column: 1;
      grid-row: 4;
    }
    .p-result__cta__footing__1{
      grid-column: 2;
      grid-row: 4;
    }

    .p-result__cta__contents{
      /* height: 100%; */
      .p-result__cta__contents__inner{
        display: flex;
        flex-direction: column;
        background: #ffffff;
        padding: 20px 40px 40px;
        /* height: 100%; */
      }
    }

    .p-result__cta__txt_catch{
      font-size: 26px;
      text-align: center;
      span{
        color: #ed7200;
        background:linear-gradient(transparent 60%, #ff6 60%);
      }
      sup{
        font-size: 14px;
        vertical-align: super;
      }
    }

    .p-result__cta__img{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      /* height: 100%; */
      margin: 30px auto;
      position: relative;
      .img_01{
        /* height: 100%; */
        width: auto;
        img{
          max-height: 200px;
        }
      }
      .p-result__cta__rank{
        position: absolute;
        left: 0px;
        top: 0;
        width: calc((125/520)*100%);
      }
    }

    .p-result__cta__txt_product_name{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      text-align: center;
      font-weight: bold;
      margin-top: 0;
      flex-grow: 1;
      span{
        display: block;
        font-size: 18px;
      }
    }

    .p-result__cta__txt_price{
      display: flex;
      align-items: baseline;
      justify-content: center;
      width: 100%;
      font-size: 39px;
      font-weight: bold;
      text-align: center;
      margin-top: 10px;
      position: relative;
      span{
        font-size: 25px;
      }
      &::before{
        content: "通常価格";
        display: block;
        align-self: center;
        width: calc(5em + 10px);
        margin: 0 10px 0 0;
        padding: 5px 5px 5px 5px;
        border: solid 2px #360a08;
        border-radius: 5px;
        line-height: 1em;
        color: #360a08;
        font-size: 1.8rem;
      }
    }

    .p-result__cta__part{
      width: 80%;
      text-align: center;
      margin: 10px auto 0;
    }

    .p-result__cta__footing{
      .p-result__cta__footing__inner{
        padding: 10px 10px;
      }
      .txt_note{
        font-size: 14px;
        font-weight: bold;
      }
    }

    }
  }


	@media ${break_point_sp} {
    .p-result__section__heading{
      .p-result__section__heading__inner{
        width: 95%;
      }
      h2{
        font-size: calc((50/750)*100vw);
        position: relative;
        padding: 0;
        &::before{
          content: " ";
          display: block;
          width: calc((120/750)*100vw);
          height: calc((120/750)*100vw);
          background: url(${process.env.PUBLIC_URL}/assets/img/result/recommend02/sp/icn_leaf_left.png) no-repeat;
          background-size: 100%;
          position: absolute;
          transform: translateY(0%) rotate(-10deg);
          top: -30%;
          left: calc((30/750)*100vw);
        }
        &::after{
          content: " ";
          display: block;
          width: calc((120/750)*100vw);
          height: calc((120/750)*100vw);
          background: url(${process.env.PUBLIC_URL}/assets/img/result/recommend02/sp/icn_leaf_right.png) no-repeat;
          background-size: 100%;
          position: absolute;
          transform: translateY(0%) rotate(10deg);
          top: -25%;
          right: calc((30/750)*100vw);
        }
      }
    }

    .p-result__block_recommend02{

      .p-result__box_recommend02{
        .p-result__box__inner{
          display: block;
        }

        .p-result__cta__contents{
          .p-result__cta__contents__inner{
            padding: 30px 2% 20px;
          }
        }

        .p-result__cta__txt_catch{
          font-size: calc((36/750)*100vw);
          sup{
            font-size: calc((26/750)*100vw);
          }
        }

        .p-result__cta__img{
          margin: 20px auto;
          .img_01{
            margin-left: 20vw;
            img{
              max-height: 200px;
            }
          }
          .p-result__cta__rank{
            width: calc((220/750)*100%);
            img{
              width: 100%;
              /* max-height: initial;
              max-width: initial; */
            }
          }
        }

        .p-result__cta__txt_product_name{
          font-size: calc((40/750)*100vw);
          span{
            font-size: calc((30/750)*100vw);
          }
        }

        .p-result__cta__txt_price{
          font-size: calc((60/750)*100vw);
          span{
            font-size: calc((35/750)*100vw);
          }
          &::before{
            font-size: calc((25/750)*100vw);
          }
        }

        /* .p-result__cta__part{
        } */

        .p-result__cta__footing{
          .p-result__cta__footing__inner{
            padding: 10px 2%;
          }
          .txt_note{
            font-size: calc((25/750)*100vw);
            line-height: 1.3;
          }
          &+.p-result__cta__heading{
            margin-top: 40px;
          }
        }

      }

    }

	}
`;
